module.exports = __webpack_public_path__ + "img/3_2_3.0612925a.png";